if (!customElements.get('search-pages')) {
    customElements.define('search-pages', class SearchPage extends HTMLElement {
        constructor() {
            super();

            this.key_boards = this.querySelectorAll(".js-keyboard");
            this.switch_layout = this.querySelectorAll(".js-switch-layout");
            this.key_board_layouts = this.querySelectorAll(".js-keyboard-layout");
            this.search_field = this.querySelector(".js-search-field");
            this.key_buttons = this.querySelectorAll(".js-key");
            this.back_layout_alphabet = this.querySelectorAll(".js-back-alphabet");

            this.data = JSON.parse(document.getElementById('data_creator').textContent);
            let index_arr = [];
            this.data.map(item => {
                if (item.indexjp != '') {
                    index_arr.push(item.indexjp);
                }
                if (item.indexen != '') {
                    index_arr.push(item.indexen.toLowerCase());
                }
            });
            this.value_uique = this.removeDuplicates(index_arr);

            this.init();
        }

        init() {
            this.key_buttons.forEach((key) => {
                let value = key.getAttribute("data-value").toLocaleLowerCase();
                this.filteredData(value);

                key.addEventListener("click", (e) => {
                    let value = e.currentTarget.getAttribute("data-value").toLowerCase();
                    let url = e.currentTarget.parentElement.getAttribute("data-url");
                    let result_url = `${url}/#character-${value}`; 

                    window.location.href = result_url;
                }, this);
            }, this);

            this.search_field.addEventListener("focus", () => {
                window.addEventListener("keydown", ({ code }) => {
                    code = code.toLowerCase().replace("key", "").replace("digit", "");
                    this.key_buttons.forEach((key) => {
                        if (key.getAttribute("data-value") === code) {
                            key.classList.add("active");
                        }
                    });
                }, this);
                  
                window.addEventListener("keyup", ({ code }) => {
                    code = code.toLowerCase().replace("key", "").replace("digit", "");
                    this.key_buttons.forEach((key) => {
                        if (key.getAttribute("data-value") === code) {
                            key.classList.remove("active");
                        }
                    });
                }, this);
            }, this);

            this.switch_layout.forEach((selector) => {
                selector.addEventListener("click", (e) => {
                    let data_layout = e.currentTarget.getAttribute("data-layout");
                    if (data_layout != "layout-number") {
                        e.currentTarget.classList.add("active");
                        this.switch_layout.forEach((el) => {
                            if (el !== e.currentTarget) {
                                el.classList.remove("active");
                            }
                        });
                    }
                    
                    this.key_board_layouts.forEach((el) => {
                        if (el.getAttribute("data-layout") === data_layout) {
                            el.classList.add("active");
                        } else {
                            el.classList.remove("active");
                        }
                    });
                });
            });
        }

        filteredData(character) {
            const filteredData = this.data.filter(item => {
                const indexEN = item.indexen.toLowerCase();
                const indexJP = item.indexjp;
                return indexEN.includes(character) || indexJP.includes(character);
            });
            
            // Disable the button if no results are found
            this.toggleButtonState(character, filteredData.length === 0);
        }

        toggleButtonState(character, disable) {
            const buttons = document.querySelectorAll(`.search-pages__keyboard--key[data-value="${character}"]`);
            buttons.forEach(button => {
                if (button) {
                    button.disabled = disable;
                }
            });
        }

        removeDuplicates(arr) {
            return [...new Set(arr)];
        }
    });
  }
  